import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight, Search, X } from 'lucide-react';
import { BRANDS } from '../../data/brands';
import { NAV_ITEMS } from '../../data/navigation';
type View = {
  level: 0;
} | {
  level: 1;
  kind: 'brands';
} | {
  level: 1;
  kind: 'section';
  label: string;
};
export function MobileNav({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [view, setView] = useState<View>({
    level: 0
  });
  const [forward, setForward] = useState(true);
  useEffect(() => {
    if (open) {
      setView({
        level: 0
      });
      setForward(true);
    }
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  if (!open) return null;
  const push = (next: View) => {
    setForward(true);
    setView(next);
  };
  const back = () => {
    setForward(false);
    setView({
      level: 0
    });
  };
  const viewKey = view.level === 0 ? 'root' : view.kind === 'brands' ? 'brands' : `section-${view.label}`;
  return <div className="fixed inset-0 z-[70] flex flex-col bg-white" data-id="element-165" data-mp="1r5vqpliabzmf">
      <div className="flex h-[68px] shrink-0 items-center justify-between bg-aw-navy px-5" data-id="element-166" data-mp="tjyc3z710efr">
        <button type="button" aria-label="Iskanje" className="flex h-11 w-11 items-center justify-center text-white" data-id="element-167" data-mp="yi9ke5hoagvv">
          <Search className="h-5 w-5" data-id="element-168" data-mp="13gb5evynsq9z" />
        </button>
        <span className="font-heading text-xl text-white" data-id="element-169" data-mp="188m3rudr440f">
          Auto<span className="font-bold" data-id="element-170" data-mp="18a5i3ffuk4zk">Wallis</span>
        </span>
        <button type="button" aria-label="Zapri meni" onClick={onClose} className="flex h-11 w-11 items-center justify-center text-white" data-id="element-171" data-mp="asf93sd050dq">
          <X className="h-6 w-6" data-id="element-172" data-mp="7q10bxymmr26" />
        </button>
      </div>

      <div className="relative flex-1 overflow-hidden" data-id="element-173" data-mp="3q0f9uh0vhm5">
        <AnimatePresence initial={false} mode="wait" data-id="element-174" data-mp="3pi9a64k5p11">
          <motion.div key={viewKey} initial={{
          x: forward ? '100%' : '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: forward ? '-100%' : '100%'
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} className="absolute inset-0 flex flex-col overflow-y-auto bg-white" data-id="element-175" data-mp="hheurrbq10og">
            {view.level === 0 ? <ul data-id="element-176" data-mp="3uvs0cffy0423">
                {NAV_ITEMS.map(item => <li key={item.label} data-id="element-177" data-mp="3uxcw28dztt1j">
                    {item.kind === 'flat' ? <a href="#" onClick={onClose} className="flex min-h-[52px] items-center border-b border-slate-100 px-5 text-sm font-semibold uppercase tracking-[0.06em] text-slate-800" data-id="element-178" data-mp="3pvdsoyi96w4l">
                        {item.label}
                      </a> : <button type="button" onClick={() => push(item.kind === 'brands' ? {
                level: 1,
                kind: 'brands'
              } : {
                level: 1,
                kind: 'section',
                label: item.label
              })} className="flex min-h-[52px] w-full items-center justify-between border-b border-slate-100 px-5 text-left text-sm font-semibold uppercase tracking-[0.06em] text-slate-800" data-id="element-179" data-mp="2s4ifgri1j1ih">
                        {item.label}
                        <ChevronRight className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-180" data-mp="31zae7ynczueu" />
                      </button>}
                  </li>)}
              </ul> : <>
                <BackRow label={view.kind === 'brands' ? 'Blagovne znamke' : view.label} onBack={back} data-id="element-181" data-mp="25wdbzd1116i5" />
                <ul data-id="element-182" data-mp="20z4oqy10uca1">
                  {(view.kind === 'brands' ? BRANDS.map(b => ({
                label: b.name,
                to: `/${b.id}`
              })) : (NAV_ITEMS.find(i => i.label === view.label)?.children ?? []).map(label => ({
                label,
                to: null as string | null
              }))).map(entry => <li key={entry.label} data-id="element-183" data-mp="2klj8uuce6kmv">
                      {entry.to ? <Link to={entry.to} onClick={onClose} className="flex min-h-[52px] items-center border-b border-slate-100 px-5 text-sm font-medium text-slate-600" data-id="element-184" data-mp="2ft9bwucv0kb3">
                          {entry.label}
                        </Link> : <a href="#" onClick={onClose} className="flex min-h-[52px] items-center border-b border-slate-100 px-5 text-sm font-medium text-slate-600" data-id="element-185" data-mp="3av9yhsojnmge">
                          {entry.label}
                        </a>}
                    </li>)}
                </ul>
              </>}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}
function BackRow({
  label,
  onBack
}: {
  label: string;
  onBack: () => void;
}) {
  return <button type="button" onClick={onBack} className="flex min-h-[48px] w-full items-center gap-2 border-b border-slate-200 bg-slate-100 px-5 text-left text-xs font-bold uppercase tracking-[0.08em] text-aw-navy" data-id="element-186" data-mp="7e1f34e64ejk">
      <ArrowLeft className="h-4 w-4" aria-hidden="true" data-id="element-187" data-mp="ggsutge2twh0" />
      {label}
    </button>;
}